/**
 * Ссылки на уроки по порядковому номеру внутри уровня (не по id в БД).
 */

export function getStudentLessonPath(lesson, blockIndex = null) {
    const num = lesson.lesson_number ?? lesson.id;
    const params = new URLSearchParams();
    if (lesson.level_id != null) {
        params.set('levelId', String(lesson.level_id));
    }
    if (blockIndex != null) {
        params.set('block', String(blockIndex));
    }
    const qs = params.toString();
    return `/student/lessons/${num}${qs ? `?${qs}` : ''}`;
}

export function getAdminLessonViewPath(lesson, blockIndex = null) {
    const num = lesson.lesson_number ?? lesson.id;
    const params = new URLSearchParams();
    if (lesson.level_id != null) {
        params.set('levelId', String(lesson.level_id));
    }
    if (blockIndex != null) {
        params.set('block', String(blockIndex));
    }
    const qs = params.toString();
    return `/admin/lessons/${num}/view${qs ? `?${qs}` : ''}`;
}

export function getStudentLessonShareUrl(lesson, blockIndex = null) {
    if (typeof window === 'undefined') return getStudentLessonPath(lesson, blockIndex);
    const path = getStudentLessonPath(lesson, blockIndex);
    return `${window.location.origin}${path}`;
}
